"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardCVC = exports.CardExpiry = exports.CardNumber = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactStripeElements = require("react-stripe-elements");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _StripeInput = _interopRequireDefault(require("./StripeInput"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var factory = function factory(Component, defaultLabel) {
  return function (_ref) {
    var InputLabelProps = _ref.InputLabelProps,
        InputProps = _ref.InputProps,
        _ref$fullWidth = _ref.fullWidth,
        fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? defaultLabel : _ref$label,
        labelErrorMessage = _ref.labelErrorMessage,
        error = _ref.error,
        _ref$margin = _ref.margin,
        margin = _ref$margin === void 0 ? 'normal' : _ref$margin,
        other = (0, _objectWithoutProperties2["default"])(_ref, ["InputLabelProps", "InputProps", "fullWidth", "label", "labelErrorMessage", "error", "margin"]);
    return /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
      fullWidth: fullWidth,
      margin: margin,
      label: error ? labelErrorMessage || "Invalid ".concat(label) : label,
      error: error,
      InputLabelProps: _objectSpread(_objectSpread({}, InputLabelProps), {}, {
        shrink: true
      }),
      InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
        inputProps: {
          component: Component
        },
        inputComponent: _StripeInput["default"]
      })
    }, other));
  };
};

var CardNumber = factory(_reactStripeElements.CardNumberElement, 'Credit Card Number');
exports.CardNumber = CardNumber;
var CardExpiry = factory(_reactStripeElements.CardExpiryElement, 'Expiration Date');
exports.CardExpiry = CardExpiry;
var CardCVC = factory(_reactStripeElements.CardCVCElement, 'CVV (3-digit # on back of card)');
exports.CardCVC = CardCVC;